import { useState } from 'react';
import type { Newsletter } from '@/types';
import { useAppDispatch } from '@/store/hooks';
import { deleteNewsletterThunk } from '@/store/slices/newslettersSlice';
import { fetchActionItems } from '@/store/slices/actionItemsSlice';

/** Shared delete-with-confirmation flow for newsletters, used by both the Dashboard and Newsletters list. */
export function useNewsletterDelete() {
  const dispatch = useAppDispatch();
  const [pendingDelete, setPendingDelete] = useState<Newsletter | null>(null);

  const requestDelete = (newsletter: Newsletter) => setPendingDelete(newsletter);
  const cancelDelete = () => setPendingDelete(null);

  const confirmDelete = async () => {
    if (!pendingDelete) return;
    await dispatch(deleteNewsletterThunk(pendingDelete.id)).unwrap();
    dispatch(fetchActionItems());
    setPendingDelete(null);
  };

  return { pendingDelete, requestDelete, confirmDelete, cancelDelete };
}
